module.exports = __webpack_public_path__ + "static/media/12UNCTAD20.30d4577a.jpg";